const SvgGold = props => (
  <svg
    width={24}
    height={23}
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={22.2294} rx={11.1147} fill="#DCA270" />
    <path
      d="M4.47537 16.9548C3.01479 12.4763 4.07492 3.61811 20 4.01276C14.709 4.23521 4.19679 7.13506 4.47537 16.9548Z"
      fill="white"
    />
    <path
      d="M5.42395 18.1825C16.8919 18.9718 19.6621 9.59315 19.6138 4.80518C16.2012 14.6945 9.98945 17.0314 7.31012 16.9637C7.26369 12.9244 12.0304 8.85802 14.4195 7.32974C7.38557 9.3494 5.49166 15.4064 5.42395 18.1825Z"
      fill="white"
    />
  </svg>
);
export default SvgGold;
